class HeaderCallButton {
  constructor() {
    this.button = document.querySelector('[data-call-button]');
    if (!this.button) return;

    this.popover = document.getElementById('call-popover');
    this.copyButton = document.querySelector('[data-copy-button]');
    this.copyText = document.querySelector('[data-copy-text]');
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
    this.backdrop = null;

    this.init();
  }

  init() {
    // Mobile: Convert button to direct tel link
    if (this.isMobile) {
      this.setupMobileCall();
    } else {
      // Desktop: Setup popover
      this.setupDesktopPopover();
    }

    // Handle viewport changes
    window.matchMedia('(max-width: 749px)').addEventListener('change', (e) => {
      this.isMobile = e.matches;
      if (this.isMobile) {
        this.closePopover();
        this.setupMobileCall();
      } else {
        this.setupDesktopPopover();
      }
    });
  }

  setupMobileCall() {
    const telNumber = this.button.dataset.phoneTel;
    this.button.onclick = () => {
      window.location.href = `tel:${telNumber}`;
    };
  }

  setupDesktopPopover() {
    // Remove mobile click handler
    this.button.onclick = null;

    // Toggle popover on button click
    this.button.addEventListener('click', (e) => {
      e.stopPropagation();
      this.togglePopover();
    });

    // Copy button functionality
    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => this.copyPhoneNumber());
    }

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!this.popover.contains(e.target) && e.target !== this.button) {
        this.closePopover();
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.popover.hasAttribute('hidden')) {
        this.closePopover();
        this.button.focus();
      }
    });

    // Trap focus in popover when open
    this.popover.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        this.trapFocus(e);
      }
    });
  }

  togglePopover() {
    const isHidden = this.popover.hasAttribute('hidden');
    
    if (isHidden) {
      this.openPopover();
    } else {
      this.closePopover();
    }
  }

  openPopover() {
    this.popover.removeAttribute('hidden');
    this.button.setAttribute('aria-expanded', 'true');
    
    // Create backdrop for mobile
    if (this.isMobile) {
      this.createBackdrop();
    }

    // Focus first interactive element
    setTimeout(() => {
      const firstButton = this.popover.querySelector('button, a');
      if (firstButton) firstButton.focus();
    }, 100);
  }

  closePopover() {
    this.popover.setAttribute('hidden', '');
    this.button.setAttribute('aria-expanded', 'false');
    
    if (this.backdrop) {
      this.backdrop.classList.remove('active');
      setTimeout(() => {
        this.backdrop?.remove();
        this.backdrop = null;
      }, 200);
    }
  }

  createBackdrop() {
    this.backdrop = document.createElement('div');
    this.backdrop.className = 'call-popover-backdrop';
    document.body.appendChild(this.backdrop);
    
    setTimeout(() => this.backdrop.classList.add('active'), 10);
    
    this.backdrop.addEventListener('click', () => this.closePopover());
  }

  async copyPhoneNumber() {
    const phoneNumber = this.button.dataset.phoneDisplay;
    const originalText = this.copyText.textContent;

    try {
      await navigator.clipboard.writeText(phoneNumber);
      
      // Show success feedback
      this.copyText.textContent = 'Copied!';
      this.copyButton.style.background = 'rgb(var(--color-success, 46, 125, 50))';
      
      setTimeout(() => {
        this.copyText.textContent = originalText;
        this.copyButton.style.background = '';
      }, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      this.copyText.textContent = 'Failed to copy';
      
      setTimeout(() => {
        this.copyText.textContent = originalText;
      }, 2000);
    }
  }

  trapFocus(e) {
    const focusableElements = this.popover.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeaderCallButton());
} else {
  new HeaderCallButton();
}
